import React from 'react';
import { Form } from 'react-bootstrap';



/**UI for template selection
 * Will only show on hub and sites
 */
export const TemplateHandler = (props) => {
    const mapOptions = () => {
        if (props.templates === undefined) {
            return null;
        }
        return props.templates.map((temps, index) => {
            return <option key={index + 1} value={temps.id}>{temps.name}</option>;
        });
    };
    return props.nodeType === "hub" || props.nodeType === "site" ? <Form.Group>
        <Form.Label>Templates</Form.Label>
        <Form.Control as="select" onChange={(ev) => props.onSelectTemplate(ev.target.value)}
            value={props.selectedTemplate}>
            <option key={0} value={0}>None</option>
            {mapOptions()}
        </Form.Control>
    </Form.Group> : null;
};


// WEBPACK FOOTER //
// ./src/components/tree/node/TemplateHandler.js